import React from "react";
import withStyles from "react-jss";

const styles = theme => {
    return {
        root: {
            padding: "29px 30px 0",
            width: "240px",
            height: "auto",
            borderRadius: "10px",
            backgroundColor: theme.palette.colors.charcoalGrey,
            boxShadow: "0 2px 20px 0 rgba(43, 29, 92, 0.3)",
            position: "absolute",
            left: 0,
            bottom: 0,
            transform: "translateY(100%)",
            zIndex: 2,
            "&:before": {
                content: '""',
                position: "absolute",
                width: "15px",
                height: "15px",
                transform: "rotate(45deg)",
                top: "-8px",
                left: "50%",
                backgroundColor: theme.palette.colors.charcoalGrey,
                boxShadow: "0 2px 20px 0 rgba(43, 29, 92, 0.3)",
                zIndex: 3,
            },
        },
        title: {
            fontFamily: theme.fonts.light,
            fontSize: "14px",
            lineHeight: 1.14,
            color: theme.palette.colors.white,
            width: "100%",
            marginBottom: "15px",
            "& strong": {
                fontFamily: theme.fonts.bold,
            },
        },
        buttonWrapper: {
            display: "flex",
            width: "100%",
            justifyContent: "space-between",
            marginBottom: "15px",
        },
        button: {
            width: "80px",
            height: "40px",
            borderRadius: "10px",
            border: `solid 1px ${theme.palette.colors.yellowGreen}`,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontFamily: theme.fonts.bold,
            fontSize: "14px",
            lineHeight: "1.29",
            letterSpacing: "1.6px",
            color: theme.palette.colors.yellowGreen,
            textTransform: "uppercase",
            cursor: "pointer",
        },
    };
};

class DetectRegion extends React.Component {
    static defaultProps = {
        onClickHandler: () => {},
    };

    render() {
        let classes = this.props.classes;
        let text = this.props.text;
        return (
            <div className={classes.root}>
                <div className={classes.title}>
                    {text.YOUR_CITY_IS} <strong>{this.props.name}?</strong>
                </div>
                <div className={classes.buttonWrapper}>
                    <div
                        className={classes.button}
                        onClick={() => this.props.clickAccept()}
                    >
                        {text.YES}
                    </div>
                    {React.cloneElement(this.props.linkComponent, {
                        children: (
                            <div className={classes.button}>{text.NO}</div>
                        ),
                    })}
                </div>
            </div>
        );
    }
}

export default withStyles(styles)(DetectRegion);
